import WordCloud from './WordCloud';
export default WordCloud;



// WEBPACK FOOTER //
// ./src/components/WordCloud/index.js